import { ContentFieldType } from "../../../types/cms/contentField.type";
import { SINGLE_TOKEN_REGEX } from "../internal/constants";
import { resolvePath } from "../internal/resolvePath";
import { resolveConditionals } from "../internal/resolveConditionals";
import type { ExtractedMedia, InterpolateParams } from "../types";

/**
 * Extrai `ExtractedMedia` de um template single-token `{{path|media}}`.
 * Retorna `undefined` se o template não for single-token, o tipo não for
 * `|media`, ou o valor não for um objeto estruturado de mídia.
 */
export function extractMedia({
  structure,
  template,
}: InterpolateParams): ExtractedMedia | undefined {
  const match = resolveConditionals({ template, structure }).match(SINGLE_TOKEN_REGEX);
  if (!match) return undefined;

  const [, path, type] = match;
  if (type !== ContentFieldType.MEDIA) return undefined;

  const value = resolvePath(structure, path);
  if (value == null || typeof value !== "object" || Array.isArray(value)) {
    return undefined;
  }

  return value as ExtractedMedia;
}
